module.exports = __webpack_public_path__ + "static/media/br-sp.501f3b0f.svg";